/**
 * ProtectedRoute — обёртка, которая:
 * - показывает spinner пока auth.status === 'loading'
 * - редиректит на /login, если 'anonymous'
 * - пускает рендер детей при 'authenticated'
 *
 * Используется в _authed.tsx layout route.
 */

import { Navigate } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { Spinner } from '@/shared/ui';
import { useAuth } from './useAuth';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { status } = useAuth();

  if (status === 'loading') {
    return (
      <div
        className="row center jcenter"
        style={{ minHeight: '100vh', background: 'var(--bg)' }}
      >
        <Spinner style={{ width: 34, height: 34 }} />
      </div>
    );
  }

  if (status === 'anonymous') {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
